import { RouteEnum } from '../constantes/RouteEnum';
import { pageConfigs } from '../configs/pageConfigs';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';

export interface NavigationScenario {
  isOpenFlow: boolean;
  currentFlow: string;
  isOnboardingRecovery?: boolean;
}

export const getNavigationDestination = (scenario: NavigationScenario): string => {
  const {isOpenFlow, currentFlow, isOnboardingRecovery} = scenario;
  
  // Verificar complementary step
  const schemaData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  const hasComplementaryStep = schemaData?.complementaryStepAfterOnboarding?.formFields?.length > 0;
  
  if (isOpenFlow) {
    if (currentFlow === 'Onboarding') {
      // Verificar se deve ir para complementary step
      if (hasComplementaryStep) {
        return RouteEnum.COMPLEMENTARY_STEP;
      } else {
        return RouteEnum.FINISH;
      }
    } else {
      return RouteEnum.HOME;
    }
  } else {
    // Fluxo fechado
    if (currentFlow === 'Onboarding') {
      // Verificar se deve ir para complementary step
      if (hasComplementaryStep) {
        return RouteEnum.COMPLEMENTARY_STEP;
      } else {
        return pageConfigs.otpValidation.navigateTo();
      }
    } else {
      return RouteEnum.HOME;
    }
    
    return RouteEnum.HOME;
  }
  
  // Fluxo fechado
  if (currentFlow === 'Onboarding') {
    return pageConfigs.otpValidation.navigateTo();
  }
  
  // **CASO ESPECIAL**: Authentication mas precisa seguir fluxo de onboarding
  if (currentFlow === 'Authentication' && isOnboardingRecovery) {
    return pageConfigs.otpValidation.navigateTo();
  }
  
  return RouteEnum.HOME;
};
